<script>
import { mixin } from '@/components/common.js'
import hero from './hero'
import faq from './faq'
import createPageButton from './create-page-button'
import footer from '@/components/view/c-footer'
import Hammer from '@/lib/hammer.js'

export default {
  components: {
    'c-hero': hero,
    'c-faq': faq,
    'create-page-button': createPageButton,
    'c-footer': footer
  },
  mixins: [mixin],
  data: () => ({
    slyde: [
      {image: 'assets/img/feature1.png', heading: 'ラクラク！お品書き作成', text: 'イベントで発売予定の商品を<br>事前にまとめて、簡単にお品書き作成！<br>すぐにファンにシェアできます'},
      {image: 'assets/img/feature2.png', heading: '欲しいものをサクッとリスト化！', text: 'お客様は、お会計前までに<br>サクッと欲しいものリストを作れます<br>ログインしなくてもOK！'},
      {image: 'assets/img/feature3.png', heading: '慌てずお買い物ができる！', text: '合計でいくらになるかも<br>その場ですぐにわかるので<br>予算オーバーを気にせずお買い物！'},
      {image: 'assets/img/feature4.png', heading: '簡単QRコードでミスが軽減！', text: 'お客様の欲しいものリストは<br>QRコードを出してお店に見せるだけ！<br>お互いのミスも負担も減らせます'}
    ],
    slydeIndex: 0
  }),
  watch: {
    slydeIndex (value) {
      this.$refs.slydeItems.style.transform = 'translateX(-' + 100 * value + '%)'
    }
  },
  mounted () {
    const el = document.querySelector('.lp .feature .slyde-items')
    const hammer = new Hammer(el)
    hammer.on('swipeleft', e => {
      this.slydeIndex = Math.min(this.slydeIndex + 1, this.slyde.length - 1)
    })
    hammer.on('swiperight', e => {
      this.slydeIndex = Math.max(this.slydeIndex - 1, 0)
    })
  }
}
</script>

<template>
  <div class="lp">
    <c-hero/>
    <create-page-button/>
    <section class="feature has-text-centered">
      <h1 class="has-text-weight-bold is-cs-3 is-c-text">カチャログの特徴</h1>
      <hr class="line">
      <div class="slyde">
        <div class="slyde-items" ref="slydeItems">
          <div
            class="slyde-item"
            v-for="s in slyde"
            :key="s.image"
            @click="slydeIndex = (slydeIndex + 1) % 4"
          >
            <figure class="image">
              <img :src="s.image">
            </figure>
            <div>
              <h2 class="has-text-weight-bold">{{ s.heading }}</h2>
              <p class="is-cs-5" v-html="s.text"></p>
            </div>
          </div>
        </div>
        <nav>
          <ul class="level-item">
            <li
              v-for="(s, i) in slyde"
              :key="i"
              @click="slydeIndex = i"
              :class="{current: slydeIndex === i}"
            >●</li>
          </ul>
        </nav>
      </div>
    </section>
    <c-faq/>
    <create-page-button/>
    <c-footer/>
  </div>
</template>

<style scoped>
.lp {
  background-color: #fff;
}
.lp .create-page {
  padding: 4rem 0;
}
/*
 * feature
 */
.lp .feature {
  margin: 0 auto 2rem;
}
.lp .feature .slyde {
}
.lp .feature .slyde .slyde-items {
  display: flex;
  align-items: center;
}
.lp .feature .slyde .slyde-items .slyde-item {
  min-width: 100vw;
}
.lp .feature .slyde .slyde-items .slyde-item .image {
  width: 10.5rem;
  height: 10.5rem;
  margin: 1rem auto;
}
.lp .feature .slyde {
  width: 100%;
  overflow: hidden;
}
.lp .feature .slyde .slyde-items {
  transform: translateX(0);
  transition: all 0.3s ease;
}
.lp .feature .slyde .slyde-items .slyde-item h2 {
  margin-bottom: .5rem;
}
.lp .feature .slyde .slyde-items .slyde-item p {
  line-height: 1.125rem;
}
.lp .feature .slyde nav {
  margin: 1rem;
  font-size: .75rem;
}
.lp .feature .slyde nav li {
  margin: 0 .25rem;
  color: #d6d6d6;
}
.lp .feature .slyde nav li.current {
  color: #028AC5;
}
</style>



// WEBPACK FOOTER //
// src/components/view/lp/index.vue